// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ob9Hw","col":"styles_col__FplGJ"};